import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { ASC } from '../internal/constants';
import { getPageRows, validateSortKey } from '../internal/helpers';


// sort all rows based on sort key and order
var getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
  if (!sortKey || !head) return rows;
  if (!rows) return [];

  // return value which will be used for sorting
  var getSortingCellValue = function getSortingCellValue(cells) {
    return cells.reduce(function (result, cell, index) {
      return result || head && head.cells[index].key === sortKey && (cell.key !== undefined ? cell.key : cell.content);
    }, null);
  };

  // reorder rows in table based on sorting cell value
  return rows.slice().sort(function (a, b) {
    var valA = getSortingCellValue(a.cells);
    var valB = getSortingCellValue(b.cells);

    // modifier used for sorting type (ascending or descending)
    var modifier = sortOrder === ASC ? 1 : -1;
    if (!valA || valA < valB) return -modifier;
    if (!valB || valA > valB) return modifier;
    return 0;
  });
};

// get one page of data in table, sorting all rows previously
export default function withSortedPageRows(WrappedComponent) {
  return function (_Component) {
    _inherits(WithSortedPageRows, _Component);

    function WithSortedPageRows() {
      _classCallCheck(this, WithSortedPageRows);

      return _possibleConstructorReturn(this, (WithSortedPageRows.__proto__ || _Object$getPrototypeOf(WithSortedPageRows)).apply(this, arguments));
    }

    _createClass(WithSortedPageRows, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        validateSortKey(this.props.sortKey, this.props.head);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) {
          validateSortKey(nextProps.sortKey, nextProps.head);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            rows = _props.rows,
            head = _props.head,
            sortKey = _props.sortKey,
            sortOrder = _props.sortOrder,
            rowsPerPage = _props.rowsPerPage,
            page = _props.page,
            restProps = _objectWithoutProperties(_props, ['rows', 'head', 'sortKey', 'sortOrder', 'rowsPerPage', 'page']);

        var sortedRows = getSortedRows(head, rows, sortKey, sortOrder) || [];
        var pageRows = getPageRows(page, sortedRows, rowsPerPage);

        return React.createElement(WrappedComponent, _extends({ pageRows: pageRows, head: head }, restProps));
      }
    }]);

    return WithSortedPageRows;
  }(Component);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/hoc/withSortedPageRows.js
// module id = 388
// module chunks = 0